import useNetworkRequest from "./useNetworkRequest";

const useEdd = ({
  dependencyCondition = false,
  dependencyList = []
}: {
  dependencyCondition?: boolean;
  dependencyList?: any[];
}) =>
  useNetworkRequest({
    networkCallParams: {
      url: "v2/limits/edd/progress",
      method: "GET",
      service: "wallet"
    },
    dependencyCondition,
    dependencyList
  });

export default useEdd;
